import { useEffect, useState } from "react";
import {  useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { LoadingSpinner, Modal, ModalPDF } from "../../../../components";
import SupportingMaterialService from "../../../../services/SupportingMaterialService";
import ModalIMG from "../../../../components/ModalIMG";
import ModalYouTube from "../../../../components/ModalYouTube";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, arrayMove} from "@dnd-kit/sortable";
import SortableSubCategoryItem from "./SortableSubCategoryItem";
import HelperFile from "../../../../helpers/helperFile";

const SupportingMaterialSubCategoryAdmin = () => {
    const { idcat } = useParams<{ idcat: string }>();
    const [category, setCategory] = useState<any>(null);
    const [subCategory, setSubCategory] = useState<any>([]);
    const [file, setFile] = useState<HTMLInputElement | null>(null);
    const [isLoad, setIsLoad] = useState<Boolean>(false);
    const [showPdf, setShowPdf] = useState<Boolean>(false);
    const [showIMG, setShowIMG] = useState<Boolean>(false);
    const [showYouTube, setShowYouTube] = useState<Boolean>(false);
    const [urlPdfView, setUrlPdfView] = useState<string | null>(null);
    const [subUrl, setSubUrl] = useState<string | null | undefined>(null);
    const [showModalCategory, setShowModalCategory] = useState<boolean>(false);
    const [showModalAddItem, setShowModalAddItem] = useState<boolean>(false);
    const [newSubCategory, setnewSubCategory] = useState({
        id:0,
        title: "",
        subTitle: "",
        SupportingMaterialCategoryId: idcat,
        description: "",
        Active: true,
        isSeparator: false
    });
    const [newItem, setNewItem] = useState({
        id:0,
        title: "",
        subTitle: "",
        description: "",
        urlFile: "",
        subUrl: "",
        fileInsert:null,
        fileMimeType: 3,
        supportingMaterialSubCategoryId:0,
        active: true
    });
    const getCategory = async (id:number) => {
         if(id<= 0) return;
         setIsLoad(true);
         SupportingMaterialService.getCategorySubAndItemsById(id)
            .then((response: any) => {
                if (response) { setCategory(response); setSubCategory(response.subCategories.sort((a: any, b: any) => a.ordem - b.ordem)); }
                setIsLoad(false);
            }).catch((error: any) => {setIsLoad(false); });
    }
    useEffect(() => {
        getCategory(Number(idcat??"0"));
    }, []);
    const openModalAddCategory = () => {
        setnewSubCategory({ id:0, title: "", subTitle: "", description: "",SupportingMaterialCategoryId: idcat, Active:true, isSeparator: false });
        setShowModalCategory(true);
    };
    const saveCategory = async () => {
        if (!newSubCategory.title) {
            toast.error("Informe o título!");
            return;
        }

        try {
            setIsLoad(true);
            if((newSubCategory.id??0) >0){
                await SupportingMaterialService.updateSubCategory(newSubCategory);
                toast.success("Sub Categoria alterada com sucesso!");
            }else{
                await SupportingMaterialService.setSubCategory(newSubCategory);
                toast.success("Sub Categoria criada com sucesso!");
                setnewSubCategory({id:0, title: "", subTitle: "",SupportingMaterialCategoryId: category.id, description: "", Active:true, isSeparator: false });
            }
            setShowModalCategory(false);
            await getCategory(category.id);

        } catch (error) {
            toast.error("Erro ao salvar Sub categoria");
        } finally {
            setIsLoad(false);
        }
    };
   const deleteCategory = async (id: number) => {
        Modal.question({
            title: "Confirmação",
            body: "Realmente deseja excluir essa Sub Categoria? Após essa ação não será possível recuperar.",
            callBack: async () => {
            try {
                setIsLoad(true);

                await SupportingMaterialService.deleteSubCategory(id);

                toast.success("Sub Categoria excluída com sucesso!");
                await getCategory(category.id);

            } catch {
                toast.error("Erro ao excluir");
            } finally {
                setIsLoad(false);
            }
            }
        });
    };
   const deleteItem = async (id: number) => {
        Modal.question({
            title: "Confirmação",
            body: "Realmente deseja excluir esse item? Após essa ação não será possível recuperar.",
            callBack: async () => {
            try {
                setIsLoad(true);

                await SupportingMaterialService.deleteItem(id);

                toast.success("Item excluída com sucesso!");
                await getCategory(category.id);

            } catch {
                toast.error("Erro ao excluir");
            } finally {
                setIsLoad(false);
            }
            }
        });
    };
    const toggleActiveCategory = async (cat: any) => {
        try {
            setIsLoad(true);

            await SupportingMaterialService.updateSubCategory({
                ...cat,
                active: !cat.active
            });

            await getCategory(category.id); // 🔥 recarrega lista

        } catch {
            toast.error("Erro ao atualizar status");
        } finally {
            setIsLoad(false);
        }
    };
    const openModalEditCategory = (cat:any) => {
        setnewSubCategory(cat);
        setShowModalCategory(true);
    };
    const openModalAddItem = (id:number) => {
        setNewItem({ ...newItem, supportingMaterialSubCategoryId:id});
        setShowModalAddItem(true);
    };
    const openModalEditItem = (item:any, idSub:number) => {
        setNewItem({...item, supportingMaterialSubCategoryId:idSub});
        setShowModalAddItem(true);
    };
    const saveItem = async (idsubcat:number) => {
        try {
            if (!newItem.title) {
                toast.error("Informe o título");
                return;
            }

            if (((newItem?.id??0) === 0) && [3, 4].includes(newItem.fileMimeType) && !newItem.urlFile) {
                toast.error("Informe a URL");
                return;
            }

            if (((newItem?.id??0) === 0) && [1, 2].includes(newItem.fileMimeType) && !file) {
                toast.error("Selecione um arquivo");
                return;
            }

            setIsLoad(true);

            const formData = new FormData();

            formData.append("Id", String(newItem.id));
            formData.append("Title", newItem.title);
            formData.append("SubTitle", newItem.subTitle);
            formData.append("SubUrl", newItem.subUrl);
            formData.append("Description", newItem.description);
            formData.append("Active", String(newItem.active));
            formData.append("FileMimeType", String(newItem.fileMimeType));
            formData.append("SupportingMaterialSubCategoryId", String(newItem.supportingMaterialSubCategoryId));

            if ([3, 4].includes(newItem.fileMimeType)) {
                formData.append("UrlFile", newItem.urlFile);
            } else {
                if(file)
                    formData.append(
                        "UrlFile",
                        (await HelperFile.uploadFiles(file, "SupportingMaterial"))[0]
                    );
            }
            
            if((newItem.id??0) > 0){
                await SupportingMaterialService.updateItemForm(formData);
            }else{
                await SupportingMaterialService.insertItem(formData).then((response: any)=>{
                    toast.success("Item salvo com sucesso!");
                    setShowModalAddItem(false);
                    setFile(null);

                    setNewItem({
                        id:0,
                        title: "",
                        subTitle: "",
                        description: "",
                        urlFile: "",
                        subUrl: "",
                        fileInsert:null,
                        fileMimeType: 3,
                        supportingMaterialSubCategoryId: Number(subCategory.id),
                        active:true
                    });

                    getCategory(Number(idcat??"0"));
                }).catch((error: any) => {
                    setIsLoad(false);
                    Modal.show({
                    title: "Erro",
                    body: Modal.getErrorMessage(error, null),
                    showCancel: true,
                    showConfirm: false,
                    onCancelText: "Fechar"
                    });
                });
            }
        } catch {
            toast.error("Erro ao salvar item");
        } finally {
            setIsLoad(false);
        }
    };
    const openForType = (mineType:number, url:string, subUrl?:string | null | undefined) => {
        
        if(mineType === 1)
            openModalViewPdf(url);
        else if(mineType === 2)
            openModalViewIMG(url);
        else if(mineType === 3)
            openModalViewYoutube(url, subUrl);
        else
            window.open(url, '_blank');

    }
    const openModalViewPdf = (urlPdf:string) => {
        setUrlPdfView(urlPdf);
        setSubUrl(null);
        setShowPdf(true);
    };
    const openModalViewIMG = (urlPdf:string) => {
        setUrlPdfView(urlPdf);
        setSubUrl(null);
        setShowIMG(true);
    };
    const openModalViewYoutube = (urlPdf:string, subUrl?:string | null | undefined) => {
        setUrlPdfView(urlPdf);
        setSubUrl(subUrl);
        setShowYouTube(true);
    };
    const getNameTypeFile = (id:number) => {
        switch (id){
            case 1:
                return "PDF";
            case 2:
                return "Imagem";
            case 3:
                return "YouTube";
            case 4:
                return "Link Externo";
            case 6:
                return "Separador";
            default:
                return "Tipo não encontrado!";
        }
    };
    const toggleActiveItem = async (item: any) => {
        try {
            setIsLoad(true);

            await SupportingMaterialService.updateItem({
                ...item,
                active: !item.active
            });

            await getCategory(category.id); // 🔥 recarrega lista

        } catch {
            toast.error("Erro ao atualizar status");
        } finally {
            setIsLoad(false);
        }
    };
    return (
        <>
            {
                isLoad === true &&
                <LoadingSpinner />
            }
            {
                (showPdf && urlPdfView) &&
                    <ModalPDF fileUrl={urlPdfView} titleType="PDF" onClose={() => setShowPdf(false)} />
            }
            {
                (showIMG && urlPdfView) &&
                    <ModalIMG fileUrl={urlPdfView} onClose={() => setShowIMG(false)} />
            }
            {
                (showYouTube && urlPdfView) &&
                    <ModalYouTube fileUrl={urlPdfView} subUrl={subUrl} onClose={() => setShowYouTube(false)} />
            }
            <div className="col-sm-8" style={{position:'relative', maxWidth: 800, borderBottom:'1px solid #dddddd', background:'#ffffff', padding:10, paddingBottom:20}}>
                <h4><span style={{display:'inline-block', marginTop:5}}>Editar categoria: {category?.title}</span></h4>
            </div>
            <div className="col-sm-8" style={{position:'relative', maxWidth: 800, borderBottom:'1px solid #dddddd', background:'#ffffff', padding:10, paddingBottom:20}}>
                <h2><span style={{display:'inline-block', marginTop:5}}>Sub Categorias:</span>
                    <button className="btn" style={{ alignSelf: "center", padding:0,  float:'right', background:'transparent'}} onClick={() => {openModalAddCategory();}}>
                        <i className="mdi mdi-plus-circle" style={{fontSize: 24, color:'#007733'}} />
                    </button>
                </h2>
                {
                    (category?.isHighlight??false) &&
                        <span style={{display:'block', marginTop:5, fontSize:12, color:'#aaaaaa'}}>* Caso não vá utilizar Sub Categorias, apenas crie uma Sub Categoria chamada "UNICO";</span>
                }
                {showModalCategory && (
                    <div style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    }}>
                        
                        <div style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 8,
                        width: 400
                        }}>
                        {
                            (newSubCategory.id) ?
                                <h4>Editar</h4>
                            :
                                <h4>Nova Sub Categoria</h4>
                        }

                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

                            <input
                            type="text"
                            placeholder="Título"
                            className="form-control"
                            value={newSubCategory.title}
                            onChange={(e) =>
                                setnewSubCategory({ ...newSubCategory, title: e.target.value })
                            }
                            />
                            {
                                newSubCategory.isSeparator !== true &&
                                <>
                                    <input
                                    type="text"
                                    placeholder="Subtítulo"
                                    className="form-control"
                                    value={newSubCategory.subTitle}
                                    onChange={(e) =>
                                        setnewSubCategory({ ...newSubCategory, subTitle: e.target.value })
                                    }
                                    />

                                    <textarea
                                    placeholder="Descrição"
                                    className="form-control"
                                    value={newSubCategory.description}
                                    onChange={(e) =>
                                        setnewSubCategory({ ...newSubCategory, description: e.target.value })
                                    }
                                    />
                                </>
                            }
                            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
                                type="checkbox"
                                checked={newSubCategory.isSeparator}
                                onChange={(e) =>
                                setnewSubCategory({
                                    ...newSubCategory,
                                    isSeparator: e.target.checked
                                })
                                }
                            />
                            É um separador
                            </label>
                        </div>

                        <div style={{ marginTop: 15, display: "flex", justifyContent: "flex-end", gap: 10 }}>
                            <button
                            className="btn btn-secondary"
                            onClick={() => setShowModalCategory(false)}
                            >
                            Cancelar
                            </button>

                            <button
                            className="btn btn-success"
                            onClick={async () => {
                                await saveCategory();
                                setShowModalCategory(false);
                            }}
                            >
                            Salvar
                            </button>
                        </div>

                        </div>
                    </div>
                )}
                <div>
                    <DndContext
                        collisionDetection={closestCenter}
                        onDragEnd={(event) => {
                            const { active, over } = event;

                            if (!over || active.id === over.id) return;

                            const oldIndex = subCategory.findIndex((i:any) => i.id === active.id);
                            const newIndex = subCategory.findIndex((i:any) => i.id === over.id);

                            const newItems = arrayMove(subCategory, oldIndex, newIndex);
                            setSubCategory(newItems);

                            const payload = newItems.map((item:any, index:number) => ({
                                id: item.id,
                                ordem: index + 1
                            }));

                            SupportingMaterialService.updateSubCategoryOrdem(payload);
                        }}
                    >
                        <SortableContext
                            items={subCategory?.map((i:any) => i.id)}
                            strategy={verticalListSortingStrategy}
                        >
                            {subCategory?.map((subCat:any) => (
                                <SortableSubCategoryItem
                                    key={subCat.id}
                                    subCat={subCat}
                                    openModalEditCategory={openModalEditCategory}
                                    deleteCategory={deleteCategory}
                                    toggleActiveCategory={toggleActiveCategory}
                                    openModalAddItem={openModalAddItem}
                                    openModalEditItem={openModalEditItem}
                                    deleteItem={deleteItem}
                                    toggleActiveItem={toggleActiveItem}
                                    getNameTypeFile={getNameTypeFile}
                                    openForType={openForType}
                                />
                            ))}
                        </SortableContext>
                    </DndContext>
                </div>
            </div>
            {showModalAddItem && (
                <div
                    onClick={() => setShowModalAddItem(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 999
                    }}
                >
                    <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        background: "#fff",
                        padding: 20,
                        borderRadius: 8,
                        width: 420
                    }}
                    >
                    <h4>{newItem?.id ? "Editar Item" : "Novo Item"}</h4>

                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>

                        {/* Tipo */}
                        <select
                        className="form-control"
                        value={newItem.fileMimeType}
                        onChange={(e) =>
                            setNewItem({
                            ...newItem,
                            fileMimeType: Number(e.target.value),
                            urlFile: ""
                            })
                        }
                        >
                        <option value={3}>YouTube</option>
                        <option value={4}>Link Externo</option>
                        <option value={1}>PDF</option>
                        <option value={2}>Imagem</option>
                        <option value={6}>Separador</option>
                        </select>

                        {/* Título */}
                        <input
                        type="text"
                        placeholder="Título"
                        className="form-control"
                        value={newItem.title}
                        onChange={(e) =>
                            setNewItem({ ...newItem, title: e.target.value })
                        }
                        />
                        {
                            newItem.fileMimeType !== 6 &&
                            <>
                            {/* Subtítulo */}
                            <input
                            type="text"
                            placeholder="Subtítulo"
                            className="form-control"
                            value={newItem.subTitle}
                            onChange={(e) =>
                                setNewItem({ ...newItem, subTitle: e.target.value })
                            }
                            />

                            {/* Descrição */}
                            <textarea
                            placeholder="Descrição"
                            className="form-control"
                            value={newItem.description}
                            onChange={(e) =>
                                setNewItem({ ...newItem, description: e.target.value })
                            }
                            />

                            
                            {[3, 4].includes(newItem.fileMimeType) ? (
                                <>
                                <input
                                    type="text"
                                    placeholder={
                                    newItem.fileMimeType === 3
                                        ? "URL do YouTube"
                                        : "URL externa"
                                    }
                                    className="form-control"
                                    value={newItem.urlFile}
                                    onChange={(e) =>
                                    setNewItem({ ...newItem, urlFile: e.target.value })
                                    }
                                />
                                {
                                    newItem.fileMimeType === 3 &&
                                        <input
                                            type="text"
                                            placeholder="Link para 'Acessar pelo YouTube (Playlist)'"
                                            className="form-control"
                                            value={newItem.subUrl}
                                            onChange={(e) =>
                                            setNewItem({ ...newItem, subUrl: e.target.value })
                                            }
                                        />
                                }
                                
                                </>
                                ) : (
                                    <>
                                    {
                                    ((newItem.id??0) >0)  &&
                                        <button className="btn btn-info" onClick={()=>{openForType(newItem.fileMimeType, newItem.urlFile, newItem.subUrl)}}> Ver Arquivo Atual</button>
                                    }
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept={
                                        newItem.fileMimeType === 1
                                            ? "application/pdf"
                                            : "image/*"
                                        }
                                        onChange={(e) => {
                                        const f = e.target;
                                        if (f) setFile(f);
                                        }}
                                    />
                                    </>
                                )}
                            </>
                        }

                    </div>

                    {/* BOTÕES */}
                    <div
                        style={{
                        marginTop: 15,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 10
                        }}
                    >
                        <button
                        className="btn btn-secondary"
                        onClick={() => setShowModalAddItem(false)}
                        >
                        Cancelar
                        </button>

                        <button
                        className="btn btn-success"
                        onClick={()=>{saveItem(subCategory.id)}}
                        >
                        Salvar
                        </button>
                    </div>
                    </div>
                </div>
                )
            }
            <Modal />
        </>
    );
};

export default SupportingMaterialSubCategoryAdmin;